/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Image } from "antd";
// import DashboardLogo from "../../assets/images/landing/kashmir-2.jpg";
// import SingaporeImg from "../../assets/images/landing/singapore.jpg";
// import Bangkok from "../../assets/images/landing/bangkok.jpg";
// import Himachal from "../../assets/images/landing/himachal.jpg";
// import AsiaCruise from "../../assets/images/landing/cruise.jpg";
// import Mauritius from "../../assets/images/landing/mauritius.jpg";
// import Saudi from "../../assets/images/landing/saudi.jpg";
// import Lakshadeep from "../../assets/images/landing/lakshadeep.jpg";
import "./index.css";
import useMedia from "use-media-antd-query";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { loadBestSellingDetailsImages } from "../../store/dashboard/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";
import PropTypes from "prop-types";

const BannerContent = () => {
  const media = useMedia();
  const dispatch = useDispatch();
  const history = useHistory();

  //store integrations

  useEffect(() => {
    dispatch(loadBestSellingDetailsImages());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { best_selling_details = [] } = useSelector((state) => state.Dashboard);

  // function SampleNextArrow(props) {
  //   const { className, style, onClick } = props;
  //   return (
  //     <div
  //       className={className}
  //       style={{
  //         ...style,
  //         // display: block;
  //         background: "rgba(0, 0, 0, 0.25)",
  //         height: "40px",
  //         borderRadius: "40px",
  //         width: "40px",
  //         padding: "10px",
  //         fontWeight: "700",
  //         marginRight: "14px",
  //         zIndex: 10,
  //       }}
  //       onClick={onClick}
  //     >
  //       <RightOutlined />
  //     </div>
  //   );
  // }

  // function SamplePrevArrow(props) {
  //   const { className, style, onClick } = props;
  //   return (
  //     <div
  //       className={className}
  //       style={{
  //         ...style,
  //         background: "rgba(0, 0, 0, 0.25)",
  //         height: "40px",
  //         borderRadius: "40px",
  //         width: "40px",
  //         padding: "10px",
  //         fontWeight: "700",
  //         marginLeft: "14px",
  //         zIndex: 10,
  //       }}
  //       onClick={onClick}
  //     />
  //   );
  // }

  const slides =
    best_selling_details !== undefined &&
    best_selling_details.length !== 0 &&
    best_selling_details.queryResult &&
    best_selling_details.queryResult.length > 0
      ? best_selling_details.queryResult.map((data) => {
          // const sizes =
          // const [width, height] =
          //   data.size && data.size.split("x").map((val) => val.trim());

          // console.log(width, "width");
          // console.log(height, "height");
          // const imgHeight = parseFloat(height);
          // const imgWidth = parseFloat(width);
          return {
            destinationId: data.packageId,
            destinationName: data.packageName,
            lowestPrice: data.lowestPrice,
            imgHeight: 250,
            imageUrl: data.thumnailImages,
            _id: data.packageId,
          };
        })
      : [];

  const sliderRef = useRef(null);
  const [slideWidth, setSlideWidth] = useState(0);

  const getSlideWidth = () => {
    if (sliderRef.current) {
      const slickTrack =
        sliderRef.current.innerSlider.list.querySelector(".slick-track");
      const slickSlide = slickTrack?.querySelector(".slick-slide");
      if (slickSlide) {
        const width = slickSlide.getBoundingClientRect().width;
        setSlideWidth(width);
      }
    }
  };
  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    onInit: getSlideWidth, // <-- this triggers on load
    onReInit: getSlideWidth, // <-- also when resized or re-rendered
    afterChange: getSlideWidth, // <-- after sliding
    centerPadding: "3px",
    ref: sliderRef,
    slidesToShow:
      media == "xxl" && slides && slides.length >= 6
        ? 6
        : media == "xxl" && slides && slides.length < 4
        ? slides.length
        : media == "xl" && slides && slides.length >= 5
        ? 5
        : media == "xl" && slides && slides.length < 4
        ? slides.length
        : media == "lg" && slides && slides.length >= 4
        ? 4
        : media == "lg" && slides && slides.length < 4
        ? slides.length
        : media == "md" && slides && slides.length >= 3
        ? 3
        : media == "md" && slides && slides.length < 4
        ? slides.length
        : media == "sm" && slides && slides.length >= 3
        ? 2
        : media == "sm" && slides && slides.length < 4
        ? slides.length
        : 1,
    // fade: true,
    // speed: 1200,
    // autoplay: true,
    // autoplaySpeed: 2200,
    nextArrow: <SampleNextArrow marginRight="14px" />,
    prevArrow: <SamplePrevArrow marginRight="14px" />,
    // slidesToScroll: 1,
    // cssEase: "linear",
  };

  // const slides = [
  //   {
  //     id: 1,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={AsiaCruise}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Malaysia",

  //     startingPrice: "30,000 /-",
  //   },
  //   {
  //     id: 2,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Bangkok}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Bangkok",
  //     startingPrice: "35,000 /-",
  //   },
  //   {
  //     id: 3,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Himachal}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Himachal",
  //     startingPrice: "12,000 /-",
  //   },

  //   {
  //     id: 5,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Mauritius}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: `Europe`,
  //     startingPrice: "50,000 /-",
  //   },
  //   {
  //     id: 6,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={SingaporeImg}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Singapore",
  //     startingPrice: "38,000 /-",
  //   },
  //   {
  //     id: 4,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={DashboardLogo}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Kashmir",
  //     startingPrice: "15,000 /-",
  //   },
  //   {
  //     id: 7,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Lakshadeep}
  //         height={250}
  //         className="border border-solid rounded-md"
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "USA",
  //     startingPrice: "70,000 /-",
  //   },
  // ];

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="mt-4">
        <Row>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pl-[40px] pr-[40px]"
                : "pt-3 pl-[80px] pr-[80px]"
            }
            style={{
              fontFamily: "Poppins",
            }}
          >
            <div>
              <h1 className="text-[24px] font-extrabold flex">
                Best Selling Packages
                {/* Plan Mi Trip Best Selling Tour Packages */}
              </h1>
            </div>
          </Col>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className="pt-3 pb-3 pl-[80px] pr-[80px]"
          >
            <div
              style={{
                // width: "100%",
                marginTop: "25px",
              }}
            >
              {slides && slides.length > 0 ? (
                <Slider {...settings} centerMode className="h-[100%]">
                  {/* <Slider {...settings} centerMode className="h-[280px]"> */}
                  {slides.map((slide, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() => {
                          history.push({
                            pathname: `/package-details/${slide.destinationName}`,
                            state: slide,
                          });
                        }}
                        className="cursor-pointer h-[250px] pr-2 pl-2"
                      >
                        {/* <h2 className="text-[black]">{slide.content}</h2> */}
                        <Image
                          preview={false}
                          alt="no-img"
                          src={slide.imageUrl}
                          width={"100%"}
                          className="object-cover border border-solid rounded-md"
                          height={slide.imgHeight}
                        />
                        <div className="w-[100%] z-10">
                          <p
                            style={{
                              position: "absolute",
                              top: "0px",
                              bottom: "5px",
                              //   marginLeft: "1px",
                              // width: lengthOfSlide + "%",
                              color: "#ffffff",
                              fontSize: "18px",
                              fontFamily: "Poppins",
                              fontWeight: 700,
                              //   zIndex: 20,
                              padding: "20px",
                              width: slideWidth && parseFloat(slideWidth - 18),
                              background: "#0000002b",
                              borderRadius: "8px",
                            }}
                            // className="w-half"
                            // className="h-[250px] absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-50 transition-colors duration-300"
                          >
                            {slide.destinationName}
                          </p>
                          <div
                            style={{
                              position: "absolute",
                              bottom: "5px",
                              marginLeft: "1px",
                              color: "#f1f1f1ed",
                              fontSize: "14px",
                              fontWeight: 700,
                              zIndex: 20,
                              padding: "20px 20px",
                            }}
                          >
                            <h1
                              style={{
                                display: "flex",
                                flexDirection:
                                  media == "lg" ||
                                  media == "md" ||
                                  media == "sm" ||
                                  media == "xs"
                                    ? "column"
                                    : "row",
                              }}
                            >
                              <p
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                Starting at
                              </p>
                              <div className="flex">
                                <p className="ml-1 mr-1 text-[14px]">{"₹  "}</p>
                                <p
                                  className=""
                                  style={{
                                    fontFamily: "Poppins",
                                    fontWeight: 800,
                                    fontSize: "14px",
                                    marginTop: "1px",
                                  }}
                                >
                                  {slide.lowestPrice !== null
                                    ? slide.lowestPrice
                                    : 0}
                                </p>
                              </div>
                            </h1>
                            <div
                              style={{
                                fontFamily: "Poppins",
                                marginTop: "-2px",
                              }}
                            >
                              Per Person
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              ) : (
                <div className="text-center images-label text-[16px]">
                  No Packages found
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
BannerContent.propTypes = {
  location: PropTypes.any,
};
export default BannerContent;
